import { saveSystem } from '../systems/SaveSystem';
import { dogNames } from './SpriteExtractionConfig';

export function playerAppearance(): { character: string; texture: string; frame: string } {
  const theme = saveSystem.settings.theme;
  const character = theme === 'walker' ? 'walker' : theme === 'penguin' ? 'penguin' : 'cat';
  return { character, texture: theme === 'cat' ? 'summer' : theme, frame: `${character}/idle/0` };
}

export function enemyAppearance(type: string): { character: string; texture: string; frame: string } {
  const theme = saveSystem.settings.theme;
  return {
    character: theme === 'cat' ? type : `${theme}-${type}`,
    texture: theme === 'cat' ? 'summer' : theme,
    frame: `dogs/${dogNames[type]}/front`,
  };
}

export function tileTexture(kind: string, world: number): string {
  const theme = saveSystem.settings.theme;
  return theme === 'penguin' ? `ice_${kind}` : theme === 'walker' ? `walker_${kind}` : `tex_${kind}_w${world}`;
}

export function environmentAtlas(): string {
  const theme = saveSystem.settings.theme;
  return theme === 'penguin' ? 'winter' : theme === 'walker' ? 'walker' : 'summer';
}

export function bombAtlas(): string { return playerAppearance().texture; }
export function powerUpAtlas(_type: string): string { return playerAppearance().texture; }
export function crateBreakAnimation(): string {
  const atlas = environmentAtlas();
  return atlas === 'summer' ? 'crate:break' : `${atlas}:crate:break`;
}
